import React from 'react';

interface IconHueProps {
    width?: number | string;
    height?: number | string;
    color?: string;
}

const IconHue: React.FC<IconHueProps> = ({ width = 17, height = 17, color = 'black' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 17 17"
        fill="none"
    >
        <g clip-path="url(#clip0_5822_17269)">
            <path
                d="M7.20328 15.6682L6.95317 15.8342C5.03645 17.1289 2.43459 16.6224 1.14207 14.7057C-0.150437 12.791 0.353941 10.1892 2.27068 8.89664C2.83391 8.51625 3.48124 8.27876 4.15797 8.20521C4.31349 8.1884 4.46902 8.17788 4.62454 8.17578C5.45468 8.17788 6.26595 8.42797 6.95317 8.89453L7.20118 9.06268L7.05197 9.32328C5.9633 11.2043 5.9633 13.5245 7.05197 15.4076L7.20328 15.6682Z"
                fill={color}
            />
            <path
                d="M12.6695 4.63782C12.6674 5.38182 12.4698 6.11109 12.0936 6.75211L12.0411 6.83618C11.5051 7.69786 10.6729 8.33467 9.7019 8.6289L9.45602 8.70456L9.32782 8.48177C9.29629 8.42502 9.25847 8.37038 9.21432 8.31994C8.10256 7.05894 6.5221 6.30866 4.84077 6.24352H4.62429L4.55072 6.03756C4.38681 5.58778 4.30273 5.1128 4.30273 4.63364C4.30273 2.32391 6.17532 0.449219 8.48715 0.449219C10.799 0.451323 12.6716 2.326 12.6695 4.63782Z"
                fill={color}
            />
            <path
                d="M16.3982 13.5663C15.8623 15.3485 14.2125 16.5633 12.3504 16.5465C10.0407 16.5465 8.16602 14.6718 8.16602 12.3621C8.16812 11.8556 8.26271 11.3554 8.44553 10.8846L8.54851 10.6156L8.82594 10.687C8.93734 10.7165 9.05294 10.7249 9.16641 10.7123C10.77 10.5252 12.2348 9.7161 13.2457 8.45928L13.3844 8.28906L13.5946 8.3542C15.8077 9.01833 17.0623 11.3512 16.3982 13.5663Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="clip0_5822_17269">
                <rect width="17" height="17" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default IconHue;
